module.exports = __webpack_public_path__ + "img/chokodadler_choko.756777a5.jpg";